export const ServiceData = [
  {
    id: 1,
    name: "Kemi Thomas",
    title: "CEO/Founder",
    img: "/images/kemi.png",
    para:
      "The fundamental difference between learnerkia and other lms is the ability to customise to meet your company’s needs.",
  },
  {
    id: 2,
    name: "John Obi",
    title: "Accountant",
    img: "/images/obi.png",
    para:
      "Learnerkia brings a 10x multiplier in terms of both ease of use and speed.",
  },
  {
    id: 3,
    name: "Suliat Rabiu",
    title: "Student",
    img: "/images/sully.png",
    para:
      "I think what really does it for me are the group forums. Conversing with other users on the platform has been instrumental to my learning.",
  },
];

export default ServiceData;
